import {Icon} from "../../Shared/Model/GameData";

interface QuizMapProps {
    image: string
    icons: Icon[]
}

export default function QuizMap(props: QuizMapProps) {
    return <div className="quiz-map">
        <img src={props.image} alt="" className="background"/>
        {props.icons.map((icon, i) => <IconView icon={icon} key={i}/>)}
    </div>
}

function IconView(props: { icon: Icon }) {
    return <div className="icon-wrapper" style={{
        top : (props.icon.position.y * 100) + '%',
        left : (props.icon.position.x * 100) + '%',
    }}>
        <img src={props.icon.picture} alt="" />
    </div>;
}
